import React, { useState } from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/modalsActions';
import { Formik, Form, Field } from 'formik';
import { Form as bootStrapForm, Col, Button, Spinner } from 'react-bootstrap';
import CyberSecurity from '../../apis/cyberSecurityData';
import * as yup from 'yup';

const schema = yup.object({
    replyMessage: yup.string().max(600).matches(/^[ A-Za-z0-9_.&?!:',-/()\n]*$/, 'Only Characters and Numbers Allowed').required(),
});

function FeedbackActionForm(props) {
    const [updated, setUpdated] = useState(false)
    const [submitting, setSubmitting] = useState(false);
    const [viewRecaptcha, setViewRecaptcha] = useState(false);

    const renderTextAreaField = ({ field, form, meta }, label) => {
        return (
            <bootStrapForm.Group >
                {/* <bootStrapForm.Label>Expertise</bootStrapForm.Label> */}
                <Col className="px-0" sm={12}>
                    <bootStrapForm.Control isInvalid={meta.error} {...field} as="textarea" type="textarea" placeholder={label} style={{ height: 100 }} />
                    {meta.touched && meta.error && <div className="error" style={{ color: '#ff4040' }}>{meta.error}</div>}
                </Col>
            </bootStrapForm.Group>
        )
    }

    return (
        <Formik
            validationSchema={schema}
            // validate={values => validate(values)}
            onSubmit={async (values, { resetForm }) => {
                const response = await CyberSecurity.post('/sfreply', { ...values, messageId: props.message._id }, {
                    headers: {
                        Authorization: `Bearer ${props.accessToken}`
                    }
                });
                props.updateMessage(response.data.updatedMessage)
                props.hideModal();
            }}
            initialValues={{
                replyMessage: props.message.replyMessage || '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                validateField,
                isSubmitting
            }) => (
                <Form autoComplete="off" className="mt-4">

                    <Field name="replyMessage">
                        {({ field, form, meta }) => renderTextAreaField({ field, form, meta }, 'Please share your thoughts*')}
                    </Field>

                    <div className="d-flex flex-column justify-content-center  align-items-center pb-4">
                        <Button variant="primary" type="submit" size="lg" onClick={() => setViewRecaptcha(true)} className="mt-4">
                            Reply to the user
                                {submitting ? <Spinner className="ml-3" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                        </Button>
                    </div>
                    <h3 className={`mt-3 ${updated && isValid ? null : 'd-none'}`} style={{ color: 'white' }} >Message Sent</h3>
                </Form>
            )}
        </Formik>
    );
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser,
        accessToken: state.accessToken
    }
}

export default connect(mapStateToProps, { hideModal })(FeedbackActionForm);
